import { RuntimeConfig } from '@nuxt/schema'
import { useLayoutStore } from '~/stores/layout'
import BreadcrumbItem from '~/models/BreadcrumbItem'

interface UseCommonStructuredDataParams {
    config: RuntimeConfig
    i18nTranslate: Function
    breadcrumbsItems: BreadcrumbItem[]
    addSearchAction: boolean
}

interface PotentialAction {
    '@type': string
    target: string
    'query-input': string
}

export default (params: UseCommonStructuredDataParams) => {
    const layoutStore = useLayoutStore()

    const structuredDataArray: any[] = []

    const website = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        url: params.config.public.apiUrl,
        name: params.i18nTranslate('mainTitle'),
        potentialAction: null as PotentialAction | null,
    }
    if (params.addSearchAction) {
        website.potentialAction = {
            '@type': 'SearchAction',
            target: `${params.config.public.apiUrl}${params.i18nTranslate('url.search')}?q={search_term_string}`,
            'query-input': 'required name=search_term_string',
        }
    }
    structuredDataArray.push(website)

    structuredDataArray.push({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: params.i18nTranslate('siteHeader.logoTitle'),
        url: params.config.public.apiUrl,
        logo: `${params.config.public.apiUrl}/images/svg/pilulka-logo.svg`,
        contactPoint: [
            {
                '@type': 'ContactPoint',
                telephone: params.i18nTranslate('footer.customerSupport.phone'),
                email: params.i18nTranslate('footer.customerSupport.email'),
                contactType: 'customer service',
            },
        ],
        sameAs: layoutStore.socialProfiles,
    })

    if (params.breadcrumbsItems && params.breadcrumbsItems.length) {
        structuredDataArray.push({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: params.breadcrumbsItems.map((item, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                item: {
                    '@id': item.url,
                    name: item.title,
                },
            })),
        })
    }

    return structuredDataArray
}
